import {CP, initParam} from "../setting/initParam";
import {
    calcColumnLine, centeredColumnLineL, createDefaultMaterial, InitialStruct,
    matBeam, MPos,
    ParamsCalcColumnLine,
    ParamsGetSimpleBoard,
    RenderElement,
    RenderStruct,
    simpleSize,
    updateLimitedPointsOnLine
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";

export async function getPillar(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const paramsCalcColumnLine: ParamsCalcColumnLine = {
        l: s.l,
        maxSpan: initParam.setting.pillarMaxSpan,
    }
    const columnLine = calcColumnLine(paramsCalcColumnLine)

    const centeredColumnLine = centeredColumnLineL(columnLine, s.l)
    const lineCenteredCut = updateLimitedPointsOnLine(centeredColumnLine, sBoard.w)
    const lineCut = updateLimitedPointsOnLine(columnLine, sBoard.w)
    const lineCutF1 = updateLimitedPointsOnLine(columnLine, initParam.elementData.f1.sizeBoard.w)
    const lineCutRafter = updateLimitedPointsOnLine(columnLine, initParam.elementData.rafter.sizeBoard.w)

    CP.maps.pillar.line = columnLine
    CP.maps.pillar.lineCenteredCut = lineCenteredCut
    CP.maps.pillar.lineCentered = centeredColumnLine
    CP.maps.pillar.lineCut = lineCut
    CP.maps.rafter.lineCut = lineCutRafter
    CP.maps.f1.lineCut = lineCutF1

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: sBoard.l},
        cuts: [],
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []

    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'K'
    const specID = nameGroup
    rs.group = nameGroup
    const numGroups = rs.group.length
    for (let i = 0; i < lineCenteredCut.length; i++) {

        const posL:MPos = [lineCenteredCut[i][0], s.h / 2, +s.w / 2 - sBoard.w / 2]
        const posR:MPos = [lineCenteredCut[i][0], s.h / 2, -s.w / 2 + sBoard.w / 2]

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [0,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(boardL)
        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [0,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(boardR)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "Столб",
        group: nameGroup,
        count: lineCenteredCut.length * 2,
        specId: specID
    })
    specIds.push(specID)
    rs.specIds = specIds

    return {rs:rs, spec: spec}
}
